<template>
  <div>
    <v-dialog v-model="show" persistent max-width="80em">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ this.card_title }}</span>
        </v-card-title>
        <v-card-text v-if="show">
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <uploader-component v-if="show" @emptyData="emptyData"/>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <preview-table :displayData="displayData"/>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12" v-if="action_for == 'user_imports'">
              <user-form />
            </div>
            <div class="col-sm-12" v-if="action_for == 'office_imports'">
              <office-form />
            </div>
          </div>
        </v-card-text>
        <h4 class="text-center red--text">
              {{errorMessage}}
        </h4>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog()">Close</v-btn>
          <user-save-button :disableSave="disableSave" :action_for="this.action_for" :errorMessage="this.errorMessage"/>
          <office-save-button :disableSave="disableSave" :action_for="this.action_for" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading-overlay v-if="loading"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import UploaderComponent from "./FileUpload";
import PreviewTable from "./PreviewTable";
import UserForm from "./user/CreateForm";
import UserSaveButton from "./user/SaveButton";
import OfficeForm from "./office/CreateForm";
import OfficeSaveButton from "./office/SaveButton";
import LoadingOverlay from "../common/LoadingOverlay";

export default {
  components: {
    UploaderComponent,
    PreviewTable,
    UserForm,
    UserSaveButton,
    OfficeForm,
    OfficeSaveButton,
    LoadingOverlay,
  },
  props: {
    card_title: String,
    action_for: String,
    show: Boolean,
  },
  data: () => ({
    dialog: false,
    errorMessage: "",
    email_list: [],
    csv_email_list: [],
    displayData: true,
    disableSave: false
  }),
  methods: {
    emptyData(val, val2) {
      this.displayData = val;
      this.disableSave = val2;
    },
    closeDialog() {
      this.$store.dispatch("file_imports/clear_table");
      this.email_list = []
      this.csv_email_list = []
      this.errorMessage = ""
      this.$emit("closeDialog", false);
    },
    validate() {
      if(this.action_for ==  'user_imports'){
        if(this.email_list.some(item => this.csv_email_list.includes(item)))
        this.errorMessage = "Email already exist"
        if(new Set(this.csv_email_list).size !== this.csv_email_list.length)
        this.errorMessage = "Duplicate email found in imported file"
      }
    }
  },
  computed :{
    ...mapState({
      loading: (state) => state.file_imports.loading,
      data: (state) => state.file_imports.data,
    }),
    ...mapGetters([
        "allUsers",
    ]),
  },
  watch: {
     data() {
        this.email_list = []
        this.csv_email_list = []
        this.errorMessage = ""
        this.allUsers.forEach(item => {
          this.email_list.push(item.email)
        })
        this.data.forEach(item => {
          this.csv_email_list.push(item.email)
        })
        this.validate();
     }
  },
  created: function () {
    this.$store.dispatch("file_imports/set_action_request", this.action_for);
  },
};
</script>
